<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card-title class="pb-5">
              <!--                                    v-if="$can('transaction_create')"-->
              <v-btn :to="{name:'users'}" rounded color="#A5668B" class="text-white">
                <v-icon>mdi-backspace-reverse-outline</v-icon>
                بازگشت
              </v-btn>
              <v-spacer/>
           ویرایش اطلاعات کاربر
              <v-spacer/>
              <v-btn @click="updateUser" color="#50858B" rounded
                     class="text-white">
                <v-icon>mdi-content-save</v-icon>
                ذخیره
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>

            <v-card-text class="pt-6">
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                      v-model="name"
                      label="نام و نام خانوادگی"
                      outlined
                      class=""
                      required
                      dense
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                      v-model="email"
                      label="ایمیل"
                      outlined
                      class=""
                      required
                      dense
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                      v-model="phone"
                      label="شماره تلفن"
                      outlined
                      class=""
                      required
                      dense
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">


                  <v-text-field
                      v-model="username"
                      label="نام کاربری"
                      outlined
                      required
                      dense
                      class=""
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                      v-model="password"
                      label="رمز عبور"
                      outlined
                      type="password"
                      dense
                      class=""></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <role-picker v-model="role" :value="roles" ></role-picker>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import RolePicker from "@/view/pages/pickers/rolePicker";

export default {
  name: "Edit",
  components: {RolePicker},
  props: ['id'],
  data() {
    return {
      name: null,
      email: null,
      phone: null,
      role: null,
      roles:null,
      username: null,
      password: '',


    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
    this.findUser();
  },
  methods: {
    findUser() {
      this.requestApiGet('user/' + this.id).then(({data}) => {
        this.name = data.name;
        this.email = data.email;
        this.phone = data.phone;
        this.username = data.username;
        this.role = data.roles[0].id
      });
    },

    updateUser() {
      this.requestApiPost(`user/${this.id}`, {
        name: this.name,
        email: this.email,
        phone: this.phone,
        username: this.username,
        password: this.password,
        _method: 'PUT',
        role: this.role
      }).then(({data}) => {
        this.$toast.success('کاربر با موفقیت ویرایش شد.');
        this.$router.push({name: 'users'})
      })
    }



  }

}
</script>

<style scoped>

</style>